import { Icon, IconProps } from '@mui/material';
import { FC } from 'react';

const IconWrapper: FC<IconProps> = ({ ...props }) => <Icon {...props} />;

export default IconWrapper;
